<main
  class="login-page"
  :style="{ backgroundImage: `url(${require('@/assets/medias/images/login-background.jpg')})` }"
>
  <div class="login-page__dialog-container">
    <m-panel
      class="login-page__dialog-container__informations"
      :border="false"
      :shadow="true"
      :padding-body="false"
    >
      <m-panel
        :border="false"
        skin="darker"
      >
        <h3 slot="header">
          {{ $i18next.t('modules.authentication.login.LoginPage.informations_container.title') }}
        </h3>
        <p v-html="$i18next.t('modules.authentication.login.LoginPage.informations_container.content.basic_informations')" />
        <transition
          name="fade-fast"
          mode="out-in"
        >
          <template v-if="inscriptionLieuExamenInformations && inscriptionLieuExamenInformations.session">
            <p v-html="$i18next.t('modules.authentication.login.LoginPage.informations_container.content.semester_related_informations', inscriptionLieuExamenInformations.session)" />
          </template>
        </transition>
      </m-panel>
      <m-panel
        :border="false"
        class="login-page__dialog-container__form"
      >
        <h3 slot="header">
          {{ $i18next.t('modules.authentication.login.LoginPage.form_container.title') }}
        </h3>
        <authentication-form />
      </m-panel>
    </m-panel>
  </div>
</main>